// extracted by mini-css-extract-plugin
export default {"loader_container":"index-module--loader_container--WyDEI"};